import jsCookie from "js-cookie";
import moment from "moment";
import Vue from "vue";
import { CLOSE_RATING, OPEN_RATING } from "../../store/modules/ratingModule";
import store from "../../store/store";

class RatingService {
    constructor() {
        // Instance timer
        this.cookie = {
            rateKey: "hl_rating_remember",
            closeTimesKey: "hl_rating_close_times",
        };

        this.month = 30;
        this.day = 1000 * 60 * 60 * 24;

        this.previousTimerInstance = null;
    }

    closeTimes() {
        const _closeTimes = Number(jsCookie.get(this.cookie.closeTimesKey));
        return Number.isNaN(_closeTimes) ? 0 : _closeTimes;
    }

    setCloseTimes(value = 1) {
        return jsCookie.set(this.cookie.closeTimesKey, value);
    }

    removeCloseTimes() {
        return jsCookie.remove(this.cookie.closeTimesKey);
    }

    isDisplayed() {
        return jsCookie.get(this.cookie.rateKey);
    }

    setDisplayedExpires(type = "day", value = 1) {
        if(type === "date") {
            jsCookie.set(this.cookie.rateKey, new Date().getTime(), {
                expires: new Date(moment(value, "DD-MM-YYYY HH:mm:ss").toISOString()),
            });
            this.removeCloseTimes();
            return;
        }

        const expiresAt =
            new Date().getTime() +
            (type === "day"
                ? this.day * Number(value)
                : type === "month"
                ? this.day * (this.month * Number(value))
                : 0);

        jsCookie.set(this.cookie.rateKey, new Date().getTime(), {
            expires: new Date(expiresAt),
        });
    }

    removeDisplayedExpires() {
        jsCookie.remove(this.cookie.rateKey);
    }

    /**
     * Support calling the callback after the millisecond and debounce action
     * 
     * @param {number} ms The milliseconds will run the callback
     * @returns 
     */
    openRatingModalAfter(ms = 100) {
        if (this.previousTimerInstance)
            clearTimeout(this.previousTimerInstance);

        if (this.isDisplayed()) {
            return;
        }

        this.previousTimerInstance = setTimeout(() => {
            // Re-check because we need lazy load data in api 
            // and set cookie after that 
            if(this.isDisplayed()) return;

            store.dispatch(OPEN_RATING);
        }, ms);
    }

    clearTimeoutRatingModal() {
        if (this.previousTimerInstance)
            clearTimeout(this.previousTimerInstance);
    }

    /**
     * The action closing rating modal
     * 
     * @param {Boolean} requestToApi Should send api to save data close rating modal of user
     * @returns Promise
     */
    async closeRatingModal(requestToApi = true) {
        return new Promise(async (resolve, reject) => {
            if(requestToApi) {
                try {
                    const res = await Vue.axios.post("/rating/close");
                    const { data } = res.data;
                    const { close_times, expired_at } = data;
        
                    this.setCloseTimes(close_times);
                    this.setDisplayedExpires("date", expired_at);
        
                    store.dispatch(CLOSE_RATING);
                    
                    return resolve(data.data);
                } catch(e) {
                    return reject(e);
                }
            }
            else {
                store.dispatch(CLOSE_RATING);
                resolve();
            }
        })
    }

    /**
     * Submit data rating of user to api
     * 
     * @param {{ 
     *  rating_scores: number, 
     *  options: Array, 
     *  message: String, 
     *  source: String,
     * }} data Data rating of user
     * @returns
     */
    sendUserRating(data = {}) {
        try {
            return Vue.axios.post("/rating/user-rating", data);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}

const ratingService = new RatingService();

export default ratingService;



// WEBPACK FOOTER //
// ./src/core/services/ratingService.js